"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssuedFrom = void 0;
var IssuedFrom;
(function (IssuedFrom) {
    IssuedFrom["LIVE"] = "live";
    IssuedFrom["STREAMER_PAGE"] = "streamer_page";
    IssuedFrom["INSTRUCTOR_PAGE"] = "instructor_page";
    IssuedFrom["SIDEBAR"] = "sidebar";
    IssuedFrom["TEST"] = "test";
})(IssuedFrom = exports.IssuedFrom || (exports.IssuedFrom = {}));
//# sourceMappingURL=Purchase.js.map